/* eslint-disable no-console */

export const Logger = {
  error: (message: string, error?: Error) => {
    if (window?.DD_LOGS) {
      window.DD_LOGS.getLogger?.('shared-header-footer')?.error(message, {}, error);
    }
    console.error({ message, error });
  },
  log: console.log,
};
